import { Text } from "@chakra-ui/react";
import NumberFormat from "react-number-format";

interface NumberProps {
    value: number | string,
    displayType?: any,
    thousandSeparator?: boolean,
    prefix?: string
};

const Number: React.FC<NumberProps> = ({ value, displayType, thousandSeparator, prefix }) => {
    return (<NumberFormat
        value={value}
        displayType={displayType || 'text'}
        thousandSeparator={thousandSeparator || true}
        prefix={prefix || ''}
    />);
};

export default Number;